import { TrailerType } from "../../graphql/generated";
import i18next from "i18next";

function trailerTypeLabel(trailerType: TrailerType) {
  return i18next.t(`trailers:trailerTypeEnum.${trailerType}`) as string;
}

export default trailerTypeLabel;
